import React from 'react';
import { Link } from 'react-router-dom';
import './calltoaction.css';
import { Button } from '../../atoms/Buttons/Button';

const CallToAction: React.FC = () => {
  return (
    <section className="call-to-action">
      <div className='call-to-action-content'>
        <h2>Ready to Get Started?</h2>
        <p>Contact us today to discuss your project and see how we can help you achieve your goals.</p>
        <Link to="/contact" className="cta-button">
          <Button label='Contact Us' primary={true}></Button>
        </Link>
      </div>
    </section>
  );
};

export default CallToAction;